"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cartErrorLens = exports.cartLoadingLens = exports.cartValueLens = void 0;
const lenses_1 = require("@atomic-object/lenses");
const monet_1 = require("monet");
const select_1 = require("./select");
/**
 * Lenses are the functional equivalent of the getters and setters pattern that never mutate data.
 *
 * '.get' returns the focus of the lens (a path or prop).
 *
 * `.set` returns a copy of object with the focus updated to a new value.
 *
 * @atomic-object/lenses was chosen for these reasons:
 *
 * 1. It's a small library
 * 2. It's simple to use
 * 3. It's written in TypeScript and has proper types for get/set functions
 * 4. It allows us to create custom set/get functions, which means it can work with Immutable.js objects
 *
 * https://github.com/atomicobject/lenses
 *
 */
/**
 * A lens for cart value.
 */
exports.cartValueLens = lenses_1.Lens.of({
    get: (state) => (0, select_1.selectParsedCart)(state),
    set: (state, val) => state.update('cart', cart => ({
        ...cart,
        error: (0, monet_1.None)(),
        value: val
    }))
});
/**
 * A lens for cart loading.
 */
exports.cartLoadingLens = lenses_1.Lens.of({
    get: (state) => state.get('cart').loading,
    set: (state, val) => state.update('cart', cart => ({
        ...cart,
        loading: val
    }))
});
/**
 * A lens for cart error.
 */
exports.cartErrorLens = lenses_1.Lens.of({
    get: (state) => state.get('cart').error,
    set: (state, val) => state.update('cart', cart => ({
        ...cart,
        error: val
    }))
});
//# sourceMappingURL=lenses.js.map